import React, { useContext, useRef } from 'react';
import { Link, TextField } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { SurveyContext } from '@bingads-webui-campaign-react/survey-context';
import { I18n } from '../../../survey.types';
import { ErrorString, getDescription } from './common';
import { SurveyContextType } from '../../../survey-context';

interface OptionWithTextProps {
  children: React.ReactNode,
  error: string,
  option: any,
  data: string,
  setData: (key: string, value: string | undefined) => void,
  dirtyState: any,
  isSelected: boolean,
  setDirtyState: (key: string, dirtyState: boolean) => void,
  logActivity: (string) => void,
}

export const Option = (props: OptionWithTextProps) => {
  const {
    children,
    error,
    option,
    data,
    setData,
    dirtyState,
    setDirtyState,
    isSelected,
    logActivity,
  } = props;

  // @ts-ignore
  const surveyContext : SurveyContextType = useContext(SurveyContext);

  const {
    hasInput,
    href,
    linkText,
    text,
    key,
    maxLength,
    placeholder,
  } = option;

  const i18n: I18n = useContext(I18nContext);
  const {
    getSurveyConfiguration,
  } = surveyContext;

  const {
    others: {
      shouldHideInputWhenNotSelected = false,
    } = {},
  } = getSurveyConfiguration();
  const logged = useRef(false);

  return (
    <div className="customized-option">
      {children}
      {href && linkText &&
        <>
          <span>{' '}</span>
          <Link
            className="customized-option-link"
            href={href}
            target="_blank"
          >{linkText}
          </Link>
        </>
      }
      {hasInput && (shouldHideInputWhenNotSelected ? isSelected : true) &&
        <div className="customized-option-input" >
          <TextField
            styles={{
              root: {
                marginTop: '6px',
                '& .ms-TextField-description': {
                  marginTop: '4px',
                  display: 'block',
                  textAlign: 'right',
                  fontSize: 'inherit',
                  color: 'inherit',
                },
                paddingBottom: '8px',
                '& .ms-TextField-fieldGroup': {
                  borderColor: (dirtyState && isSelected && error) ? '#A80000' : undefined,
                },
              },
            }}
            ariaLabel={i18n.getString(_TL_('The input field for the option named "{{optionText}}"'), { optionText: text })}
            value={data}
            placeholder={placeholder}
            onChange={(event, value) => {
              setData(key, value);
              setDirtyState(key, true);
              if (logged.current === false) {
                logActivity(`Component: ${key}, action: input`);
                logged.current = true;
              }
            }}
            tabIndex={isSelected ? 0 : -1}
            description={maxLength != null && isSelected ? getDescription(data, maxLength, i18n) : undefined}
          />
          {dirtyState && isSelected && error && <ErrorString error={error} />}
        </div>
      }
    </div>
  );
};
